

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-phone.route', ['squid', 'xo-phone.directive']).factory('$AddPhoneRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddPhoneRoute', {

            name: 'addPhone',

            directive: 'xo-add-phone',

            titleContent: 'addPhone.addPhoneNumber',

            query: ['message'],

            trackingData: {
                templateName: 'addPhone.dust',
                fptiState: 'add_phone',
                pageGoal: 'Add Phone',
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-add-phone',
                        'pagename2': '%::fullpage-add-phone:member:hermes:',
                        'version': 'member:%:'
                    }
                    // More page qualifiers come here...
                }
            },

            loginRequired: true,

            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/phone/route.js
// module id = ./components/xo-form-components/src/phone/route.js
// module chunks = 1